import React, { useState, useContext, useEffect } from "react";
import Translation from "utils/Translation";
import { useAuth } from "react-oidc-context";
import { HotelContext } from "context/HotelContext";
import BreadCrumb from "component/Breadcrumb";
import RewardCard from "component/RewardCard";

const Rewards = () => {
  const keycloak = useAuth();
  const { hId, lang } = useContext(HotelContext);

  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [noDataAvailable, setNoDataAvailable] = useState(false);

  const fetchRewardsByHotel = () => {
    if (!keycloak.isAuthenticated || !keycloak.user?.access_token) {
      setHasError(true);
      setLoading(false);
      return;
    }

    setLoading(true);
    fetch(`/api/hotels/${hId}/rewards?lang=${lang}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + keycloak.user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-front-token": "Bs#PSQyhy)!y9Ti{",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === "OK" && data.rewards.length > 0) {
          setRewards(data.rewards);
          setHasError(false);
          setNoDataAvailable(false);
        } else {
          setNoDataAvailable(true);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching rewards:", error);
        setHasError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (keycloak.isAuthenticated && keycloak.user && hId) {
      fetchRewardsByHotel();
    }
  }, [keycloak.isAuthenticated, hId, lang]);

  return (
    <div className="green-miles-actions-container">
      <BreadCrumb text="Récompenses_title" />
      <h1 className="h1-page">
        <Translation tag={"Récompenses_title"} />
      </h1>

      <p className="cleaning-description">
        <Translation tag={"ActionRSE_text"} />
      </p>

      {loading ? (
        <div className="centered-message">Chargement des récompenses...</div>
      ) : hasError ? (
        <div className="centered-message">Erreur lors du chargement des récompenses. Veuillez réessayer.</div>
      ) : noDataAvailable ? (
        <div className="centered-message">Aucune récompense disponible.</div>
      ) : (
        <div className="actions-list">
          {rewards.map((reward) => (
            <RewardCard key={reward.rwId} name={reward.radName} description={reward.radDescription} cost={reward.rwCost} picture={reward.rwPictureURL} language={lang} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Rewards;
